import React from 'react';
import classNames from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';

import { Consulting } from '@layouts/Consulting';
import { Cloud, Header, Pipeline } from './components';
import {
	Awards,
	DescriptionWithAnimation,
	InternalLinking,
	PaddingContainer,
	QuoteWithPhoto,
	Reviews,
	WeWorkWith,
	WidthContainer,
} from '@components';
import MarekPhoto from '@images/staff/devops_marek.webp';
import CloudDifferencesPhoto from '@static/images/figures/cloud-differences.webp';
import devOpsAnimationData from '@images/animations/devOpsAnimation.json';
import { colors } from '@styles/core-styles/theme';
import { internalLinkingData, weWorkWithData } from '@store/DevOpsData';
import useReviewsQuery from '@utils/hooks/useReviewsQuery';

import * as styles from './DevOps.module.scss';

export const DevOps: React.FC = () => {
	const { directus } = useStaticQuery(graphql`
		query DevOpsReviews {
			directus {
				PageReviews(filter: { pageName: { _contains: "devops" } }) {
					Reviews {
						Reviews_id {
							quote
							reviewerName
							reviewerPosition
							link
							title
							logo {
								id
								imageFile {
									extension
									publicURL
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
					}
				}
			}
		}
	`);
	const reviews = useReviewsQuery(directus);

	return (
		<div className="z-99 relative overflow-hidden">
			<Header />
			<DescriptionWithAnimation
				className="gray-bg"
				animationData={devOpsAnimationData}
				animationOnTheRight
				animationClassName={styles.animation}
				contentClassName="d-flex flex-1"
				disableContentPadding
			>
				<div className={styles.typographies}>
					<p className="font-size-sm line-height-26 mb-4">
						DevOps connects two areas: the software development team{' '}
						<span className="font-600">(Dev)</span> with the operations team{' '}
						<span className="font-600">(Ops)</span>. This methodology emphasizes
						close communication and mutual commitment between the two divisions
						to improve both processes and product quality.
					</p>
					<p className="font-size-sm line-height-26">
						<span className="font-600">
							DevOps is responsible for the Preparation of environments at
							different
						</span>{' '}
						levels that enable respectively: software development, testing,
						performance in the development environment and implementation in
						production and Continuous Integration / Continuous Delivery (CI/CD)
						process.
					</p>
				</div>
			</DescriptionWithAnimation>
			<Pipeline />
			<PaddingContainer className="gray-bg">
				<WidthContainer>
					<QuoteWithPhoto
						background={colors.yellowOrangeGradient}
						image={MarekPhoto}
						author="MAREK, DEVOPS"
						spacing="between"
					>
						<p className="font-size-sm">
							There is a great passion for our job and implementing the best
							possible solutions. That's why we are able to meet and exceed the
							expectation of high grade SLAs. In today's world the support of
							software development processes has never been dynamic to this
							extant.
						</p>
					</QuoteWithPhoto>
				</WidthContainer>
			</PaddingContainer>
			<Cloud />
			<PaddingContainer className="gray-bg">
				<WidthContainer>
					<div
						className={classNames(
							styles.cloudDifferences,
							'd-flex justify-content-center'
						)}
					>
						<img src={CloudDifferencesPhoto} alt="Cloud differences" />
					</div>
				</WidthContainer>
			</PaddingContainer>
			<div id="technologies">
				<WeWorkWith data={weWorkWithData} />
			</div>
			<InternalLinking className="gray-bg" links={internalLinkingData} />
			{!!reviews.length && (
				<Reviews
					title="Our client says"
					reviews={reviews}
					maxWidth="1300px"
					bg="white"
					titleClass="font-size-medium"
				/>
			)}
			<Awards className="gray-bg" />
			<Consulting />
		</div>
	);
};
